import _ from 'lodash';
import urlParamManager from './urlParamManager';
import * as slides from '../utilities/slideComponents';
import SessionStorageService from '../services/utilities/SessionStorageService';

/**
 * Field Idなしでアクセスすると必ずrequest.jsの404に移動するルート
 * 作業予定一覧などのページはrails.jsxの管轄
 * 新規作成、編集系はここに入る
 */
const requiredFieldIdRoute = [
  'WorkScheduleRegister',
  'WorkScheduleEdit',
  'WorkResultRegister',
  'WorkResultEdit',
  'WorkScheduleUnapprovedEdit',
  'WorkResultUnapprovedEdit',
  'SafetyDiariesRegister',
  'GatePassageRegister',
  'MachineryUseRegister',
  'GatePassageEdit',
  'SafetyDiariesRecoveryRegister',
  'SafetyDiariesRegister',
  'CraneUseRegister',
  'LwApiSettingRegister',
  'LwGroups',
  'LwTalkrooms',
  'DirectApiSettingRedirect',
];
/**
 *
 */
class slideLoader {
  constructor() {
    this.delegate = [];

    //urlの変更は直接うけて描画する
    urlParamManager.setDelegate((split, master, slide) => {
      this.slide = slide;
      this.publishView();
    });
  }

  /**
   * 登録
   * @param {function} func
   */
  setDelegate(func) {
    this.delegate.push(func);
  }

  /**
   * コンポーネントを返す
   */
  show(component, state, vw) {
    vw = vw ? vw : 1; // 強通知はView1に表示する
    // console.log('_slideLoader.show', component, state, vw);
    //変更をプッシュステートする
    urlParamManager.setSlide(component, state, vw);
    //urlを変更する
    this.delegateUpdate(slides[component], state, vw);

    // ヘッダーの日付選択非表示
    sessionStorage.setItem('slideClosed', 0);
  }

  close(vw) {
    //SessionStorageからURLを取得
    let WorkResulturl = SessionStorageService.getItem('WorkResulturl');
    //労安から遷移してきた時の分岐
    if (WorkResulturl === null) {
      //console.log("Slide close " , vw );
      //変更をプッシュステートする
      urlParamManager.setSlide(false, null, vw);
      //urlを変更する
      this.delegateUpdate(null, null, vw);

      // ヘッダーの日付選択表示
      sessionStorage.setItem('slideClosed', 1);
    } else {
      sessionStorage.removeItem('WorkResulturl');
      // ヘッダーの日付選択表示
      sessionStorage.setItem('slideClosed', 1);
      //作業実績未入力通知からの遷移後✕ボタンで閉じる場合は作業実績一覧に遷移
      location.href = '/conference/0:1/0/0/WorkResult:1/Dashboard:0';
    }
  }

  //デリゲート
  delegateUpdate(component, state, vw) {
    _.each(this.delegate, func => {
      if (func) {
        func(component, state, vw);
      }
    });
  }

  /**
   * urlから受けたパラメータから
   * 各スライドを開く
   */
  publishView() {
    //左スライド
    if (this.slide[0]) {
      const param = this.slide[0].split(':');
      // param[1]←本来はNumber型でキャストしたものをidに入れるのが正しい(影響範囲が大きすぎるため、変更は保留)
      let props = {
        state: param[1] ? { id: param[1] } : {}, //編集id
      };

      /**
       * field_idが必須のComponentでfield_idがセットされていない時には描画しない
       * rails.jsxでErrorNotSelectedFieldが描画されるような動きとなる
       */
      if (requiredFieldIdRoute.includes(param[0])) {
        if (!SessionStorageService.getFieldId()) {
          return;
        }
      }
      this.delegateUpdate(slides[param[0]], props, 1);
    } else {
      this.delegateUpdate(null, null, 1);
    }

    //右スライド
    if (this.slide[1]) {
      const param = this.slide[1].split(':');
      let props = {
        state: param[1] ? { id: param[1] } : {}, //編集id
      };
      this.delegateUpdate(slides[param[0]], props, 2);
    } else {
      this.delegateUpdate(null, null, 1);
    }
  }
}

const _slideLoader = new slideLoader();
export default _slideLoader;



// WEBPACK FOOTER //
// ./src/utilities/slideLoader.js